import { CampaignsAction, CampaignsActionTypes, CampaignsState } from "../types/campaigns"

const initialState: CampaignsState = {
  campaigns: [],
  loaded: false,
  error: null,
}

export const campaignsReducer = (state = initialState, action: CampaignsAction): CampaignsState => {
  switch (action.type) {
    case CampaignsActionTypes.FETCH_CAMPAIGNS_LIST:
      return {
        ...state,
        loaded: true,
      }
    case CampaignsActionTypes.FETCH_CAMPAIGNS_LIST_SUCCESS:
      return {
        ...state,
        loaded: false,
        campaigns: action.payload,
      }
    case CampaignsActionTypes.FETCH_CAMPAIGNS_LIST_ERROR:
      return {
        ...state,
        error: action.payload,
      }
    default:
      return state
  }
}
